import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PlatformView } from "./PlatformView";
import { PlatformViewStore } from "../../store/PlatformViewStore";
import { useStore } from "../../../../hooks";

export const PlatformViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/platform/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PlatformViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PlatformView platformViewStore={store} />
      </PageLayout>
    </div>
  );
});
